import { render, staticRenderFns } from "./invoiceNew.vue?vue&type=template&id=2c33195a"
import script from "./invoiceNew.vue?vue&type=script&lang=js"
export * from "./invoiceNew.vue?vue&type=script&lang=js"
import style0 from "./invoiceNew.vue?vue&type=style&index=0&id=2c33195a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports